import { render, staticRenderFns } from "./indexCeco.vue?vue&type=template&id=0ae56d99&"
import script from "./indexCeco.vue?vue&type=script&lang=ts&"
export * from "./indexCeco.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports